import { render, staticRenderFns } from "./vacancies.vue?vue&type=template&id=5786451d&scoped=true&lang=pug"
import script from "./vacancies.vue?vue&type=script&lang=ts"
export * from "./vacancies.vue?vue&type=script&lang=ts"
import style0 from "./vacancies.vue?vue&type=style&index=0&id=5786451d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5786451d",
  null
  
)

export default component.exports